// extracted by mini-css-extract-plugin
export var textInput = "_ld-0";